import TagManager from 'react-gtm-module'

const gtmId: string = import.meta.env.VITE_GTM_ID
const tagManagerArgs = { gtmId }

TagManager.initialize(tagManagerArgs)
